import { Controller } from "@hotwired/stimulus"
import { useStore } from "stimulus-store"
import { sendFailureNotification } from "shared/toast_notifications"
import { getDeviceTypes } from "shared/device_types/device_types"
import { allDeviceTypesStore } from "../../../stores/device_types/all_device_types_store";

// Connects to data-controller="suppliers--device-types--device-types-supplier"
export default class extends Controller {

    static stores = [
        allDeviceTypesStore
    ]

    static values = {
        autoLoad: Boolean
    }

    connect() {
        useStore(this)

        // If autoLoad is enabled, load device types immediately
        if (this.autoLoadValue) {
            this.loadDeviceTypes()
        }
    }

    /**
     * Load all device types and populate the allDevicesStore
     */
    async loadDeviceTypes() {
        try {
            // Fetch all device types using the existing service
            const deviceTypes = await getDeviceTypes()

            // Update the store with fetched device types
            this.setAllDeviceTypesStoreValue(deviceTypes)
        } catch (error) {
            console.error('Error loading device types:', {
                error: error.message,
                timestamp: new Date().toISOString()
            })

            // Show user-friendly error message
            sendFailureNotification('Unable to load device types. Please try again.')

            // Clear device types on error
            this.setAllDeviceTypesStoreValue([])
        }
    }

    /**
     * Manually refresh device types
     */
    refreshDeviceTypes() {
        this.loadDeviceTypes()
    }

    /**
     * Clear all device types from the store
     */
    clearDeviceTypes() {
        this.setAllDeviceTypesStoreValue([])
    }
}